import Splide from '@splidejs/splide';
import '@splidejs/splide/css';
import '@splidejs/splide/css/core';

const carousels = document.querySelectorAll('.c-carousel__container');

if (carousels) {
  carousels.forEach((carousel) => {
    new Splide(carousel, {
      autoplay: true,
      autoHeight: true,
      autoWidth: false,
      arrows: true,
      clones: 0,
      fixedHeight: 350,
      fixedWidth: '100%',
      gap: '1.25rem',
      interval: 20_000,
      keyboard: true,
      lazyLoad: 'nearby',
      pagination: false,
      pauseOnFocus: true,
      pauseOnHover: true,
      perMove: 1,
      reducedMotion: {
        autoplay: false,
      },
      resetProgress: false,
      rewind: true,
      rewindSpeed: 500,
      type: 'loop',
      speed: 500,
    }).mount();
  });
}
